import axiosClient from "../../api/axiosClient.js";

function useToken(){
    const axiosAuth = axiosClient.defaults.headers.common['Authorization'];
    return axiosAuth;
}

export {useToken};
